export default "__VITE_ASSET__CEXg4iL3__"